import { render } from "./indexAbout.vue?vue&type=template&id=16c384f0"
import script from "./indexAbout.vue?vue&type=script&lang=js"
export * from "./indexAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__